// LLM generated - Model Claude 4 Sonnet
import {
  CONTEST_INFO_ALERT_TYPES,
  SERVICE_FEE_ALERT_TYPES,
} from '~/domains/contest/domains/common/constants';
import type { ServiceFeeAlert } from '~/domains/manage-contest/types';

import type { Alert } from '../interfaces/full-contest.interface';

/**
 * Type guard to check if an alert is a ServiceFeeAlert
 */
export function isServiceFeeAlert(alert: Alert): alert is ServiceFeeAlert {
  const serviceFeeTypes: readonly string[] = [
    SERVICE_FEE_ALERT_TYPES.SERVICE_FEE_DUE,
    SERVICE_FEE_ALERT_TYPES.SERVICE_FEE_CANCELLED,
    SERVICE_FEE_ALERT_TYPES.SERVICE_FEE_OVERDUE,
  ];
  return serviceFeeTypes.includes(alert.type);
}

/**
 * Filter alerts to get only ServiceFee alerts
 */
export function getServiceFeeAlerts(alerts?: { values: Alert[] }): ServiceFeeAlert[] {
  if (!alerts?.values) return [];
  return alerts.values.filter(isServiceFeeAlert);
}

const INFO_ALERT_TYPES: readonly string[] = [CONTEST_INFO_ALERT_TYPES.CONTEST_RESTARTED];

/**
 * Predicate for display-only info alerts (rendered as the gray action banner).
 * Distinct from service-fee alerts so they never trip the Pay / nav-block logic.
 * Typed on { type } only so it works across the different alert shapes.
 */
export function isInfoAlert(alert: { type: string }): boolean {
  return INFO_ALERT_TYPES.includes(alert.type);
}

/**
 * Filter alerts to only the display-only info alerts (e.g. contest_restarted).
 * Generic so it preserves the caller's alert element type.
 */
export function getInfoAlerts<T extends { type: string }>(alerts?: { values: T[] }): T[] {
  if (!alerts?.values) return [];
  return alerts.values.filter(isInfoAlert);
}

/**
 * Filter alerts by specific type
 */
export function getAlertsByType<T extends Alert>(
  alerts: { values: Alert[] } | undefined,
  typeGuard: (alert: Alert) => alert is T
): T[] {
  if (!alerts?.values) return [];

  return alerts.values.filter(typeGuard);
}

/**
 * Check if there are any ServiceFee alerts
 */
export function hasServiceFeeAlerts(alerts?: { values: Alert[] }): boolean {
  return getServiceFeeAlerts(alerts).length > 0;
}
